import React, { useEffect } from "react";
import messe from "../data/messe.json";
import { useTranslation } from "react-i18next";
import i18n from "..";
const ExibitionPage = () => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="xl:min-h-[calc(100vh-100px)] xs:min-h-[calc(100vh-265px)] h-auto'">
      <div className=" xs:pt-12 xl:pt-[200px] flex justify-center items-center flex-col xs:gap-8 md:gap-10 xl:gap-14">
        <h2 className="xs:text-[15px] md:text-[20px] xl:text-[25px] font-bold font-roboto underline underline-offset-[12px] decoration-bbf-green  text-start">
          {t("outhousemesseheadline").toUpperCase()}
        </h2>

        {/* <div className="flex justify-center xl:w-[60%] xs:w-[90%] mt-10">
        <div className="grid xl:grid-cols-2 md:grid-cols-3 xs:grid-cols-1 xs:gap-5 md:gap-12 xl:gap-24 xs:text-[15px] md:text-[20px]  mb-20 w-[80%]">
          {messe.outhouse.map((item, index) => (
            <div
              key={index}
              className="flex justify-start group items-start flex-col   cursor-pointer  xs:w-[150px] md:w-[170px] xl:w-[100%]"
            >
              <a href={item.link} target="_blank">
              <h3 className=" font-roboto xs:text-[13px] md:text-[17px]">{item.branch}</h3>
              <h5>
                {item.dates.de.map((item, index) => (
                  <div
                    key={index}
                    className="mt-3 font-roboto xs:text-[13px] md:text-[17px]  bg-[#cecaca] p-2 font-semibold"
                  >
                    {item}
                  </div>
                ))}
              </h5>
              </a>
             
            </div>
          ))}
        </div>
        </div> */}

        <div className="flex flex-col justify-center items-center w-[90%] pb-10 pt-10 gap-10">
          {messe.map((item, index) => (
            <div
              key={index}
              className="flex flex-col w-[80%] justify-center items-center gap-10 pb-10">
              <div className="xs:text-[15px] md:text-[20px] xl:text-[25px]  font-bold font-roboto underline underline-offset-[12px] decoration-bbf-green  text-center">
                {item.title}
              </div>
              <div className="flex justify-center items-center w-full xs:mt-2 md:mt-8 mb-8">
                <div
                  key={index}
                  className={`${
                    item.items.length > 1
                      ? "grid xl:grid-cols-4 md:grid-cols-3 xs:grid-cols-1"
                      : "grid xs:grid-cols-1"
                  }  xs:gap-5 md:gap-12 xl:gap-24 xs:text-[15px] md:text-[20px]`}>
                  {item.items.map((mes, index) => (
                    <div
                      className="flex flex-col justify-start items-start gap-5"
                      key={index}>
                      <a href={mes.link} target="_blank" className="flex flex-col justify-start items-start gap-5">
                        <div className="font-bold md:h-14">{mes["messe-title"]}</div>
                        <div className="bg-bbf-green p-2 text-[white]">
                          {mes.datum}
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              {item.title === "Hausmesse" ? (
                <div className="text-[18px] xs:text-[15px] font-bold">
                  Nur für den Fahrrad Fachhandel *
                </div>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExibitionPage;

